import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { FabricAccessLevel } from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';
import { SetAllUsersAccessPowerBiWorkspaceActionDefinitionModel } from 'src/app/models/api/playbooks/actions/setAllUsersAccessPowerBiWorkspaceProperties';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';

@Component({
  selector: 'app-set-all-users-access-power-bi-workspace-action',
  standalone: true,
  imports: [ReactiveFormsModule, MatRadioModule, LabelsProviderPipe],
  templateUrl: './set-all-users-access-power-bi-workspace-action.component.html',
  styleUrls: ['./set-all-users-access-power-bi-workspace-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetAllUsersAccessPowerBiWorkspaceActionComponent implements OnInit {
  @Input() public fg: UntypedFormGroup;
  @Input() public playbooksActionInput: PlaybooksActionDefinitionInput;
  @Input() public triggerType: TriggerTypes;

  public fabricAccessLevel = FabricAccessLevel;

  private _actionDefinitionModel?: SetAllUsersAccessPowerBiWorkspaceActionDefinitionModel;

  ngOnInit(): void {
    let accessLevel: FabricAccessLevel | undefined;
    if (this.playbooksActionInput.actionDefinitionProperties) {
      this._actionDefinitionModel = this.playbooksActionInput
        .actionDefinitionProperties as SetAllUsersAccessPowerBiWorkspaceActionDefinitionModel;
      accessLevel = this._actionDefinitionModel.accessLevel;
    }
    this.fg.addControl('accessLevel', new UntypedFormControl(accessLevel, [Validators.required]));
  }
}
